<template lang="html">
  <div class="details-wrapper-background">
    <div class="details-wrapper">
      <div class="tabs-wrapper">
        <div
          @click="currentTab = tab.value"
          v-for="tab in tabs"
          :key="tab.value"
          :class="{ active: currentTab === tab.value }"
        >
          {{ $t(tab.label) }}
        </div>
      </div>
      <div v-if="currentTab === 1" class="breadcrumbs-wrapper">
        <div class="link" @click="changeCategory(productInfo.cat_id_parent)">
          {{ productInfo.cat_name_parent }}
        </div>

        <template v-if="productInfo.cat_id !== productInfo.cat_id_parent">
          <div style="margin: 0px 10px;">></div>
          <div class="link" @click="changeCategory(productInfo.cat_id)">
            {{ productInfo.cat_name }}
          </div>
        </template>
      </div>
      <!-- <keep-alive> -->
      <component
        @refresh="getProductInfo()"
        :productInfo="productInfo"
        v-bind:is="currentTabComponent"
      ></component>
      <!-- </keep-alive> -->
    </div>
    <div
      v-if="currentTab === 1 && productInfo.pro_id"
      class="details-slider-wrapper"
    >
      <slider
        :user="productInfo.pro_id"
        :category="$t('details.otherProducts')"
      />
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
import Slider from '@/components/slider/slider.vue'
import Details from '@/components/details/details.vue'
import Purchase from '@/components/details/purchase.vue'
import Seller from '@/components/details/seller.vue'
import Transactions from '@/components/details/transactions.vue'
export default {
  name: 'Details',
  components: {
    Slider,
    Details,
    Purchase,
    Seller,
    Transactions
  },
  metaInfo () {
    return {
      title: this.$i18n.t('main.appName'),
      titleTemplate: '%s | ' + this.$i18n.t('main.moto'),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.productInfo.pro_description
            ? this.productInfo.pro_description
            : this.$i18n.t('main.moto')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.productInfo.pro_description
            ? this.productInfo.pro_description
            : this.$i18n.t('main.moto')
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.productInfo.pro_name
            ? this.productInfo.pro_name
            : this.$i18n.t('main.appName')
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: this.$i18n.t('main.appName')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          itemprop: 'image',
          content: require('@/assets/images/logo.png')
        },
        {
          hid: 'og:image:secure_url',
          name: 'og:image:secure_url',
          itemprop: 'image',
          content: require('@/assets/images/logo.png')
        }
      ]
    }
  },
  data () {
    return {
      tabs: [
        { label: 'details.tabs.purchase', value: 1 },
        { label: 'details.tabs.details', value: 2 },
        { label: 'details.tabs.seller', value: 3 },
        { label: 'details.tabs.transactions', value: 4 }
      ],
      currentTab: 1,
      productInfo: {}
    }
  },
  mounted () {
    this.getProductInfo()
  },
  methods: {
    getProductInfo () {
      const params = {
        id: this.$route.params.id
      }
      api
        .getProductInfo(params)
        .then(res => {
          this.productInfo = res.data.data
          if (this.productInfo) {
            for (let property in this.productInfo) {
              if (property === 'available') {
                this.productInfo[property] =
                  this.productInfo[property] +
                  ' ' +
                  this.productInfo['mun_unit']
              }
              if (property === 'quantity') {
                this.productInfo[property] =
                  this.productInfo[property] +
                  ' ' +
                  this.productInfo['mun_unit']
              }
            }
          }
        })
        .catch(e => {
          console.log(e.response.status)
          if (e.response.status == 404) {
            this.$router.push({
              name: 'Home',
              params: { lang: this.$i18n.locale }
            })
          }
        })
    },
    changeCategory (category) {
      console.log('asd')
      const query = {
        category: category
      }
      this.$router.push({
        name: 'Result',
        params: this.$route.params,
        query: query
      })
    }
  },
  computed: {
    currentTabComponent () {
      if (this.currentTab === 1) {
        return Purchase
      } else if (this.currentTab === 2) {
        return Details
      } else if (this.currentTab === 3) {
        return Seller
      } else {
        return Transactions
      }
    }
  },
  watch: {
    $route: {
      handler () {
        this.getProductInfo()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.details-wrapper-background {
  background: #f2f2f2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;

  .breadcrumbs-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
    margin-bottom: 30px;
    padding-left: 120px;
    flex-wrap: wrap;

    .link {
      cursor: pointer;
      color: $main-color;
    }
  }

  .tabs-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
    @import '@/assets/scss/scrollbarStyles.scss';
    @include scrollbar;

    div {
      padding: 0px 30px;
      padding-bottom: 5px;
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      -webkit-box-shadow: 0px 1px 0px 0px #eeeeee;
      -moz-box-shadow: 0px 1px 0px 0px #eeeeee;
      box-shadow: 0px 1px 0px 0px #eeeeee;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 12px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.06em;
      color: #898989;
      box-sizing: border-box;
      white-space: nowrap;
    }
    div.active {
      -webkit-box-shadow: 0px 2px 0px 0px $main-color;
      -moz-box-shadow: 0px 2px 0px 0px $main-color;
      box-shadow: 0px 2px 0px 0px $main-color;
      color: $main-color;
    }
    div:first-child {
      margin-left: 0;
    }
    div:last-child {
      margin-right: 0;
    }
  }
  .details-slider-wrapper {
    margin: 0 auto;
    max-width: 1600px;
    width: calc(100% - 40px);

    .slider-wrapper {
      margin-bottom: 0px;
      padding: 20px;
      box-sizing: border-box;
    }
  }
  .details-wrapper {
    background-color: white;
    margin: 0 auto;
    max-width: calc(1600px - 80px);
    width: calc(100% - 120px);
    margin-bottom: 40px;
    flex-grow: 1;
    padding: 40px;
  }
  .transactions-wrapper {
    max-width: 100vw !important;
    overflow: auto;
    @import '@/assets/scss/scrollbarStyles.scss';
    @include scrollbar;
  }
}
@media only screen and (max-width: 650px) {
  .breadcrumbs-wrapper {
    padding-left: 0px !important;
  }
  .tabs-wrapper {
    display: flex;
    // flex-wrap: wrap;
    flex-direction: row;
    justify-content: flex-start !important;
    align-items: flex-start;
    overflow: auto;
    box-sizing: border-box;

    div {
      // min-width: 143px !important;

      white-space: nowrap;
      padding: 0px 30px;
      padding-bottom: 5px !important;
      height: 20px !important;
      line-height: 20px !important;
      margin-bottom: 20px !important;
      cursor: pointer;
      -webkit-box-shadow: 0px 1px 0px 0px #eeeeee;
      -moz-box-shadow: 0px 1px 0px 0px #eeeeee;
      box-shadow: 0px 1px 0px 0px #eeeeee;
      text-transform: uppercase;
      font-weight: bold;
      font-size: 12px;
      line-height: 20px;
      text-align: center;
      letter-spacing: 0.06em;
      color: #898989;
      box-sizing: border-box;
    }
  }
}
.details-wrapper {
  background-color: white;
  margin: 0 auto;
  max-width: calc(1600px - 80px);
  width: calc(100% - 80px) !important;
  margin-bottom: 40px;
  flex-grow: 1;
  padding: 20px !important;
}
@media only screen and (max-width: 1000px) {
  .details-wrapper-background .details-wrapper {
    max-width: calc(1600px - 40px);
    width: calc(100% - 40px) !important;
    margin-bottom: 40px;
    flex-grow: 1;
    padding: 10px !important;
  }
}
</style>
